import React from 'react';
import './MiniChart.css';

const MiniChart = ({ data, label, color = '#4ECDC4', showTrend = true }) => {
  if (!data || data.length === 0) {
    return (
      <div className="mini-chart">
        <div className="mini-chart-label">{label}</div>
        <div className="mini-chart-empty">No data</div>
      </div>
    );
  }

  const values = data.map(d => d.value);
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;

  // Calculate trend
  const trend = values.length >= 2
    ? values[values.length - 1] - values[values.length - 2]
    : 0;
  const trendIcon = trend > 0 ? '📈' : trend < 0 ? '📉' : '➡️';
  const trendColor = trend > 0 ? '#2ecc71' : trend < 0 ? '#e74c3c' : '#888';

  // Normalize data points to 0-100 range for display
  const normalizedData = values.map(v => ((v - min) / range) * 100);

  // Create SVG path
  const points = normalizedData.map((value, index) => {
    const x = (index / (values.length - 1 || 1)) * 100;
    const y = 100 - value;
    return `${x},${y}`;
  }).join(' ');

  return (
    <div className="mini-chart">
      <div className="mini-chart-header">
        <div className="mini-chart-label">{label}</div>
        {showTrend && (
          <div className="mini-chart-trend" style={{ color: trendColor }}>
            {trendIcon} {Math.abs(trend).toFixed(1)}
          </div>
        )}
      </div>
      <div className="mini-chart-value">{values[values.length - 1].toFixed(1)}</div>
      <svg className="mini-chart-graph" viewBox="0 0 100 100" preserveAspectRatio="none">
        <defs>
          <linearGradient id={`gradient-${label}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={color} stopOpacity="0.3" />
            <stop offset="100%" stopColor={color} stopOpacity="0.05" />
          </linearGradient>
        </defs>
        <polyline
          fill="none"
          stroke={color}
          strokeWidth="2"
          points={points}
          vectorEffect="non-scaling-stroke"
        />
        <polygon
          fill={`url(#gradient-${label})`}
          points={`0,100 ${points} 100,100`}
        />
      </svg>
    </div>
  );
};

export default MiniChart;
